module.exports = __webpack_public_path__ + "assets/img/icon0.b2095005.png";